import React from 'react';
import AdminEmptyPage from '../../../sections/AdminDashboard/shared/AdminEmptyPage';

const Verifications = () => <AdminEmptyPage title="Verifications" />;

export default Verifications;
